export const vysePoplatku = (contract: GQL.IContract | null): number => {
  return (contract?.spravaDluhu?.pocatecni_splatka || 0) + (contract?.spravaDluhu?.vyse_splatky || 0);
};
